import React from 'react';
import { PropTypes as PT } from 'prop-types';
import LoadingComp from 'components/LoadingAnimation/LoadingAnimation';
import JoinModal from 'containers/JoinModal/JoinModalContainer';
import PageLayout from 'layouts/PageLayout/PageLayout';
import GetPermission from 'containers/GetPermission/GetPermissionContainer';
import { Redirect, withRouter } from 'react-router-dom';
import _get from 'lodash/get';
import { parse } from 'query-string';
import classes from './JoinPage.module.scss';
import { WAMP_JWT_ERROR } from 'constants/AuthError';

class JoinPage extends React.PureComponent {
  UNSAFE_componentWillMount() {
    this.props.disableOnboarding();
  }

  componentDidMount() {
    if (!this.props.isLoggedIn && !this.props.isAuthActive) {
      this.handleLogin();
    }
  }

  UNSAFE_componentWillUpdate(nextProps) {
    if (!this.props.remoteDisconnect && nextProps.remoteDisconnect && nextProps.isGuest) {
      this.props.onRemoteEndCall();
    }
  }

  getGuestName = () => {
    const parsed = parse(_get(this, 'props.location.search'));
    let name = parsed.name || this.props.name;

    if (name && name.length) {
      if (name.length > 32) {
        name = name.substring(0, 32);
      }
      return name;
    }
    return 'Guest';
  };

  getExtension = () => _get(this, 'props.match.params.extension') || _get(this, 'props.extension');

  getGroupId = () => _get(this, 'props.match.params.groupId');

  handleLogin = () => {
    this.props.beginLogin();
    this.props.registeredLogin()
      .then(() => {
        this.props.ssoEmailCheck(this.props.email).catch(() => { });
        this.props.endLogin();
      })
      .catch(error => {
        // Only attempt guest login if JWT not present
        const errMessage = _get(error, 'reason');
        if(errMessage && errMessage.includes(WAMP_JWT_ERROR)) {
          this.handleGuestLogin();
        } else {
          this.props.endLogin();
        }
      });
  };

  handleGuestLogin = () =>
    this.props.guestLogin(
      this.getGuestName(),
      this.getExtension(),
      this.props.guestEmail,
      this.getGroupId(),
    ).then(() => this.props.endLogin());

  render() {
    const extension = this.getExtension();

    if (this.props.reload || this.props.isInJoinFlowCall) {
      return null;
    }

    if (this.props.isLoggedIn && !this.props.isGuest) {
      // If not a guest, then bring up join flow modal
      setTimeout(() => {
        this.props.openJoinModal(extension);
      }, 0);
      return (<Redirect push to={'/'} />);
    } else if (this.props.isLoggedIn && this.props.isGuest) {
      // If a guest, then bring up join flow modal
      return (
        <PageLayout>
          <div className={classes.joinPage}>
            <JoinModal
              extension={extension}
              fullScreen
            />
          </div>
        </PageLayout>
      );
    } else if (this.props.isAcquiringPrimaryStream) {
      return (<GetPermission />);
    } else {
      return (<LoadingComp />);
    }
  }
}

JoinPage.propTypes = {
  extension: PT.string,
  name: PT.string,
  disableOnboarding: PT.func,
  isAcquiringPrimaryStream: PT.bool,
  isGuest: PT.bool,
  onRemoteEndCall: PT.func,
  openJoinModal: PT.func,
  match: PT.object,
  remoteDisconnect: PT.bool,
  isLoggedIn: PT.bool,
  guestLogin: PT.func,
  reload: PT.bool,
  registeredLogin: PT.func,
  beginLogin: PT.func,
  endLogin: PT.func,
  isInJoinFlowCall: PT.bool,
  ssoEmailCheck: PT.func,
  email: PT.string,
  guestEmail: PT.string,
  isAuthActive: PT.bool,
};

export default withRouter(JoinPage);
